export default {"src":"/_next/static/media/ic_right_gold.f5677411.svg","height":352,"width":192,"blurWidth":0,"blurHeight":0};